import { types } from 'mobx-state-tree';

export const WeekDays = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];

export const optionalMaybeNull = (T) =>
  types.optional(types.maybeNull(T), null);

export const TimeTable = types.model('TimeTable', {
  from: types.string,
  to: types.string,
  days: types.array(types.enumeration(WeekDays)),
});

export const Availability = types.model('Availability', {
  indicator: types.string,
  updated_at: types.string,
});

export const Street = types.model('Street', {
  formatted: types.string,
  name: types.string,
});

export const HeightRestrictions = types.model('HeightRestrictions', {
  restricted: types.boolean,
  max_cms: types.optional(types.number, 0),
});

export const Rate = types.model('Rate', {
  type: optionalMaybeNull(types.string),
  value: optionalMaybeNull(types.string),
  price: types.optional(types.number, 0),
});
export const Times = types.model('Times', {
  open: types.array(TimeTable),
});

export const GeometryType = types.model('GeometryType', {
  type: types.string,
  coordinates: types.maybeNull(types.array(types.number)),
});

export const GeometryData = types.model('GeometryData', {
  type: types.string,
  geometries: GeometryType,
});

export const DynamicProperties = types.model('DynamicProperties', {
  availability: types.array(Availability),
});

export const Address = types.model('Address', {
  street: Street,
  city: types.string,
  country: types.string,
  postcode: types.string,
  area: types.maybe(types.string),
});

export const PriceTable = types.model('PriceTable', {
  eligibility: types.string,
  active_times: types.array(TimeTable),
  rates: types.array(Rate),
});

export const RateTable = types.model('RateTable', {
  currency: types.string,
  currency_code: types.string,
  rate_table: types.array(PriceTable),
});
